/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ActionSchedule = core.serialization.enum_(["weekly", "daily", "hourly"]);
